import moment from 'moment';
import DocumentoOffline from "./db/DocumentoOffline";
import FileUtils from "./FileUtils";
import { EventBus } from "./EventBus";
import EXIF from 'exif-js';
import piexif from 'piexifjs';

var Utils = {
    minutosEntreBackups: 10,
    diasBackups: 10,
    timeoutResetBackup: null,
    sobreimprimir: false,
    posterior2Dic2024: function (fecha) {
        // si fecha tiene valor y es  tipo string, la convertimos en Date
        if (typeof fecha === 'string') {
            fecha = new Date(fecha);
        }
        return !fecha || fecha >= new Date(2024, 11, 2);
    },
    fechaEnSesionesManuales: function (fecha, sesionesManuales) {
        if (!fecha || !sesionesManuales || !sesionesManuales.length) return false;
        var toTs = function (d) {
            if (!d) return NaN;
            if (d instanceof Date) return d.getTime();
            if (typeof d === 'string') {
                var m = d.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/);
                if (m) return new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +(m[6] || 0)).getTime();
            }
            return new Date(d).getTime();
        };
        var t = toTs(fecha);
        if (isNaN(t)) return false;
        return sesionesManuales.some(function (s) {
            if (!s || !s.inicio) return false;
            var inicio = toTs(s.inicio);
            if (isNaN(inicio) || t < inicio) return false;
            if (s.fin == null) return true;
            var fin = toTs(s.fin);
            if (isNaN(fin)) return false;
            return t <= fin;
        });
    },
    /**
     * Colapsa las ráfagas de valores repetidos consecutivos de un histórico de cambios.
     * Un mismo cambio puede historificarse varias veces seguidas (7, 7, 7, 3, 7, 7), así que de
     * cada ráfaga nos quedamos con la entrada más antigua, que es la que introdujo el valor, y con
     * ella su usuario y su fecha. El ejemplo anterior queda en 7, 3, 7.
     * @param {Array} history entradas { valor, date, username, ... }
     * @param {Function} [claveValor] convierte un valor en lo que se compara; por defecto el valor tal cual
     * @returns {Array} nuevo array ordenado de más reciente a más antiguo
     */
    colapsaRafagasHistorico: function (history, claveValor) {
        if (!history || !history.length) return [];
        var clave = function (itm) {
            var v = claveValor ? claveValor(itm.valor) : itm.valor;
            if (v === undefined || v === null || v === '') return ' vacio';
            return typeof v === 'object' ? JSON.stringify(v) : String(v);
        };
        var ordenado = history.slice().sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
        var colapsado = [];
        for (var i = 0; i < ordenado.length; i++) {
            // al venir en orden descendente, la última entrada de cada ráfaga es la más antigua
            if (i === ordenado.length - 1 || clave(ordenado[i]) !== clave(ordenado[i + 1])) {
                colapsado.push(ordenado[i]);
            }
        }
        return colapsado;
    },
    onPageMounted: function () {
        if (window.location.href.indexOf("?reloadPage") > -1) {
            window.location.href = window.location.href.split('?')[0];
            window.location.reload();
        }
    },
    padZeros: function (input, maxLength) {
        if (maxLength === void 0) { maxLength = 0; }
        return ("0000" + input).slice(-maxLength);
    },
    cleanObj: function(obj) {
        for (var propName in obj) { 
            if (obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
    },
    getDireccionStr(direccion) {
        if (direccion) {
          return (direccion.direccion || '') + ' ' + (direccion.cp || '') + ' ' + (direccion.poblacion || '') + ' ' + (direccion.pais || '');
        } else {
          return '';
        }
    },
    getUser() {
        if (window.app && window.app.data && window.app.data.user && window.app.data.user.username) {
            return window.app.data.user;
        } else {
            var user = localStorage.getItem("user");
            if (typeof user == "undefined" || !user) { 
                return null;
            } else {
                user = JSON.parse(user);
                if (typeof user == "undefined" || !user) {
                    return null;
                } else {
                    return user;
                }
            }
        }
    },
    getToken() {
        var session = localStorage.getItem("session");
        if (typeof session != "undefined" && session) {
            var sessionObj = JSON.parse(session);
            if (sessionObj && sessionObj.token) {
                return sessionObj.token;
            }
        }
        return "";
    },
    orderDataByTabIndex: function (a, b) {
        if (a.tabIndex < b.tabIndex) {
          return -1;
        } else if (a.tabIndex > b.tabIndex) {
          return 1;
        } else {
          return 0;
        }
    },
    getMenu() {
        const self = this;
        const user = self.getUser();
        if (user) {
            return user.menu;
        } else {
            return null;
        }
    },
    userLoaded() {
        const self = this;
        return !!self.getUser();
    },
    isSync: function(config) {
        var momentVar = moment;
        return (config && config.syncDate && config.dispositivo && momentVar().diff(config.syncDate,'days') < 1);
    },
    focusNextElement(event, padre) {
        var self = this;
        event.preventDefault();
        if (event.target.type == 'textarea') {
            return;
        }
        var focusable = padre.querySelectorAll('input,textarea,div[contentEditable=true],span[contentEditable=true]');
        var focusableOK = [];
        for (let idx = 0; idx < focusable.length; idx++) {
            const element = focusable.item(idx);
            if (element.type != 'checkbox' && element.type != 'radio') {
                focusableOK.push(element);
            }
        }
        if (event.target.tabIndex && event.target.tabIndex > 0) {
            focusableOK.sort(self.orderDataByTabIndex);
        }
        var next = null;
        var idxNext = focusableOK.indexOf(event.target);
        if (idxNext > -1) {
            idxNext++;
        }
        if (idxNext > -1) {
            next = focusableOK[idxNext];
            if (next){
                next.focus();
                return next;
            }

        }
    },
    getProperty(name) {
        let properties = localStorage.getItem("properties");
        if (typeof properties == "undefined" || !properties) { 
            return null;
        }
        properties = JSON.parse(properties);
        if (typeof properties == "undefined" || !properties || !properties.length) {
            return null;
        }
        let p = properties.filter(p => p.nombre == name)[0];
        return p ? p.valor : null;
	},
    writeFile(fileName, dataObj, append = false) {
        var rootDir = "Documents/";
        var filePath = rootDir + fileName;

        if (!window.requestFileSystem) {
            return;
        }

        window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
            // TODO Gestionar directorios
            var folders = fileName.split("/");
            var folderToCreate = rootDir;
            for(var i=0; i<folders.length-1;i++){
                folderToCreate += folders[i] + "/";
                fs.root.getDirectory(folderToCreate, { create: true, exclusive: false }, function (fileEntry) {
                }, function(err) {
                    console.error("Error al crear directorio", err);
                });
            }
            
            fs.root.getFile(filePath, { create: true, exclusive: false }, function (fileEntry) {
                if (append) {
                    // El fallo se cuenta, como en la rama de abajo: sin `onerror` ni
                    // callback de error, un append que no cabe o que no se puede abrir no
                    // dejaba ni rastro, y lo que se pierde es el registro de la inspección.
                    fileEntry.createWriter(function (fileWriter) {
                        fileWriter.onerror = function(err) {
                            console.error("Error al añadir al fichero", err);
                        };
                        if (fileWriter.length) {
                            fileWriter.seek(fileWriter.length);
                        }
                        fileWriter.write(dataObj);
                    }, function(err) {
                        console.error("Error al abrir el fichero para añadir", err);
                    });
                    return;
                }
                // Sin `append` esto reescribe el fichero ENTERO, y `logInspeccion` repite la misma
                // ruta en cada respaldo de la misma inspeccion: si el respaldo nuevo es más corto
                // que el anterior —se quita una respuesta, una foto— escribir sin vaciar dejaba la
                // cola del viejo pegada detrás, o sea un JSON que ya no se puede leer.
                FileUtils.writeFull(fileEntry, dataObj, function () {}, function (err) {
                    console.error("Error al escribir fichero", err);
                });
            }, function(err) {
                console.error("Error al crear fichero", err);
            });
        });
    },
    appendFile(fileName, text){
        Utils.writeFile(fileName, text, true);
    },
    logInspeccion(inspeccion, nuevoFichero = false) {
        if (!inspeccion.formato) {
            return;
        }
        var timestamp = moment().format("YYYYMMDDHHmmss"),
            insp = inspeccion.id,
            provincia = inspeccion.direccionInspeccion && inspeccion.direccionInspeccion.provincia ? inspeccion.direccionInspeccion.provincia : "00",
            formato = inspeccion.formato.codigo.replaceAll(/\s/g,""),
            fichero = 'SIMECAL/' + (insp ? `${formato}/${provincia}/${insp}/${timestamp}.json` : `${formato}/${provincia}/${timestamp}.json`);
        // console.log(inspeccion);
        if (inspeccion.sincronizado) {
            return;
        }
        if (Utils.currentLogs[formato] && Utils.currentLogs[formato][provincia] && Utils.currentLogs[formato][provincia][insp]) {
            if (!nuevoFichero) {
                fichero = Utils.currentLogs[formato][provincia][insp];
            }
        } else {
            if(!Utils.currentLogs[formato]) {
                Utils.currentLogs[formato] = {};
            }
            if(!Utils.currentLogs[formato][provincia]){
                Utils.currentLogs[formato][provincia] = {};
            }
            Utils.currentLogs[formato][provincia][insp] = fichero;
            Utils.timeoutResetBackup = setTimeout(function(){
                delete Utils.currentLogs[formato][provincia][insp];
            }, Utils.minutosEntreBackups*60*1000);
        }
        Utils.writeFile(fichero, inspeccion);
    },
    log(line) {
        var date = moment().format("YYYYMMDD"),
            timestamp = moment().format("DD/MM/YYYY HH:mm:ss"),
            logFile = `SIMECAL/Logs/${date}.txt`;
        Utils.appendFile(logFile, `${timestamp} - ${line}\n`);
    },
    currentLogs: {},
    moveInspeccionToBorrar(inspeccion, localId) {
        if (!inspeccion.formato) {
            return;
        }
        var today = moment().format("YYYYMMDD"),
            insp = localId,
            provincia = inspeccion.direccionInspeccion && inspeccion.direccionInspeccion.provincia ? inspeccion.direccionInspeccion.provincia : "00",
            formato = inspeccion.formato.codigo.replaceAll(/\s/g, ""),
            newName = inspeccion.codigo ? inspeccion.codigo.replaceAll("/", "_") : localId;
        
        if (insp) {
            var folder = `Documents/SIMECAL/${formato}/${provincia}/${insp}`;
            var borrarFolder = `Documents/SIMECAL/Borrar/${today}/`;
            Utils.moveFile(folder, borrarFolder, newName);
        }
    },
    moveFile(baseFile, targetFile, newName) {
        return new Promise(async (resolve, reject) => {
            if (!window.requestFileSystem) {
                resolve();
                return;
            }
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, async function (fs) {
                var folders = targetFile.split("/");
                var folderToCreate = "";
                await DocumentoOffline.createFolders(folderToCreate, folders, fs);
                if (baseFile.startsWith("file://")) {
                    window.resolveLocalFileSystemURL(baseFile, function (baseDirEntry) {
                        fs.root.getDirectory(targetFile, { create: true, exclusive: false }, function (targetDirEntry) {
                            baseDirEntry.moveTo(targetDirEntry, newName,
                                function (res) {
                                    console.log("Fichero movido correctamente", res);
                                    resolve(res)
                                },
                                function (err) {
                                    console.error(err);
                                    reject(err);
                                });
                        }, function (err) {
                            console.error(err);
                            reject(err);
                        });
                    }, function (err) {
                        console.error(err);
                        reject(err);
                    });
                } else {
                    fs.root.getDirectory(baseFile, { create: false, exclusive: false }, function (baseDirEntry) {
                        fs.root.getDirectory(targetFile, { create: true, exclusive: false }, function (targetDirEntry) {
                            baseDirEntry.moveTo(targetDirEntry, newName,
                                function (res) {
                                    console.log("Fichero movido correctamente", res);
                                    resolve(res)
                                },
                                function (err) {
                                    console.error(err);
                                    reject(err);
                                });
                        }, function (err) {
                            console.error(err);
                            reject(err);
                        });
                    }, function (err) {
                       console.error(err);
                       reject(err);
                    });
                }
            });
        });
    },
    removeBackups() {
        return new Promise(async (resolve, reject) => {
            var dayRemove = moment().add(Utils.diasBackups * -1,"day").format("YYYYMMDD");
            var borrarFolder = `Documents/SIMECAL/Borrar`;
            var logsFolder = `Documents/SIMECAL/Logs`;
            var p = Promise.resolve();
            if (!window.requestFileSystem) {
                resolve();
                return;
            }
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
                p = p.then(_ => new Promise(function(resolve, reject) {
                    fs.root.getDirectory(borrarFolder, { create: true, exclusive: false }, function (borrarEntry) {
                        let readerDir = borrarEntry.createReader();
                        readerDir.readEntries(function (entries) {
                            entries.forEach(entry => {
                                if (entry.isDirectory) {
                                    let nameEntry = entry.name;
                                    if (nameEntry < dayRemove) {
                                        entry.removeRecursively();
                                    }
                                }
                            });
                            resolve();
                        },function (err) {
                            console.error(err);
                            reject(err);
                        })
                        
                    }, function (err) {
                       console.error(err);
                       reject(err);
                    });
                }));
                p = p.then(_ => new Promise(function(resolve, reject) {
                    fs.root.getDirectory(logsFolder, { create: true, exclusive: false }, function (borrarEntry) {
                        let readerDir = borrarEntry.createReader();
                        readerDir.readEntries(function (entries) {
                            entries.forEach(entry => {
                                if (entry.isFile) {
                                    let nameEntry = entry.name.split('.')[0];
                                    if (nameEntry < dayRemove) {
                                        entry.remove();
                                    }
                                }
                            });
                            resolve();
                        },function (err) {
                            console.error(err);
                            reject(err);
                        })
                        
                    }, function (err) {
                       console.error(err);
                       reject(err);
                    });
                }));
                p.then(resolve).catch(reject);
            });
        });
    },
    getHistoricoInspeccion(inspeccion) {
        return new Promise(async (resolve, reject) => {
            var insp = inspeccion.id,
                provincia = inspeccion.direccionInspeccion && inspeccion.direccionInspeccion.provincia ? inspeccion.direccionInspeccion.provincia : "00",
                formato = inspeccion.formato.codigo.replaceAll(/\s/g,""),
                folder = `Documents/SIMECAL/${formato}/${provincia}/${insp}`;
            
            if (!window.requestFileSystem) {
                resolve();
                return;
            }
            
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
                fs.root.getDirectory(folder, { create: false, exclusive: false }, function (inspDir) {
                    let readerDir = inspDir.createReader();
                    readerDir.readEntries(function (entries) {
                        let historico = [];
                        var p = Promise.resolve();
                        entries.forEach(entry => {
                            if (entry.isFile) {
                                p = p.then(_ => new Promise(function (resolve, _) {
                                    entry.getMetadata(function (m) {
                                        historico.push({
                                            file: entry.name,
                                            date: moment(m.modificationTime).format("DD/MM/YYYY HH:mm")
                                        });
                                        resolve();
                                    }, function () {
                                        historico.push({
                                            file: entry.name,
                                            date: moment(entry.name.split()[0], "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm")
                                        });
                                        resolve();
                                    })
                                }));
                            }
                        });
                        p.then( _ => resolve(historico.reverse())).catch(reject);
                    },function (err) {
                        console.error(err);
                        reject(err);
                    })
                    
                }, function (err) {
                    console.error(err);
                    reject(err);
                });
            });
        });
    },
    getHistItem(inspeccion, file) {
        return new Promise(async (resolve, reject) => {
            var insp = inspeccion.id,
                provincia = inspeccion.direccionInspeccion && inspeccion.direccionInspeccion.provincia ? inspeccion.direccionInspeccion.provincia : "00",
                formato = inspeccion.formato.codigo.replaceAll(/\s/g,""),
                fichero = `Documents/SIMECAL/${formato}/${provincia}/${insp}/${file}`;
            
            if (!window.requestFileSystem) {
                resolve();
                return;
            }
            
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
                fs.root.getFile(fichero, { create: false, exclusive: false }, function (fileEntry) {
                    fileEntry.file(function (file) {
                        var reader = new FileReader();
                        reader.onloadend = function(evt) {
                            console.log("read success");
                            console.log(evt.target.result);
                            resolve(evt.target.result);
                        };
                        reader.readAsText(file);
                    }, function (err) {
                        console.error(err);
                        reject(err);
                    })
                }, function (err) {
                    console.error(err);
                    reject(err);
                });
            });
        });
    },
    executeTask: async function (timeLimit, task, failureValue) {
      let timeout;
      const timeoutPromise = new Promise((resolve, reject) => {
          timeout = setTimeout(() => {
              resolve(failureValue);
          }, timeLimit);
      });
      const response = await Promise.race([task, timeoutPromise]);
      if(timeout){ //the code works without this but let's be safe and clean up the timeout
          clearTimeout(timeout);
      }
      return response;
    },
    limpiarInstruccionesComprobaciones: function(comprobaciones) {
        if (!comprobaciones) return;
        comprobaciones.forEach(function(c) {
            delete c.instrucciones;
            delete c.instruccionesDoc;
            if (c.hijas && c.hijas.length) {
                Utils.limpiarInstruccionesComprobaciones(c.hijas);
            }
        });
    },
    limpiarInstruccionesElementos: function(tabs) {
        if (!tabs) return;
        tabs.forEach(function(tab) {
            if (tab.items) {
                tab.items.forEach(function(item) {
                    Utils.limpiarInstruccionesComprobaciones(item.comprobaciones);
                });
            }
        });
    },
    limpiarFormatoExpediente: function(formato) {
        if (!formato) return;
        delete formato.listadoCondicionesAuditoria;
        delete formato.condicionesAuditoria;
        delete formato.auditoriaGPT;
        delete formato.comprobaciones;
        delete formato.caracteristicas;
        delete formato.tabs;
        delete formato.provincias;
    },
    // Elimina de forma recursiva las claves indicadas en CUALQUIER nivel de un objeto/array.
    // Se usa para asegurar que las condiciones de auditoría no viajen en ningún sitio del
    // expediente al sincronizar (formato, formatoOrigen, historicoOffline, etc.).
    eliminarClavesProfundo: function(obj, claves) {
        if (!obj || typeof obj !== 'object') return;
        if (Array.isArray(obj)) {
            for (var i = 0; i < obj.length; i++) {
                Utils.eliminarClavesProfundo(obj[i], claves);
            }
            return;
        }
        for (var c = 0; c < claves.length; c++) {
            delete obj[claves[c]];
        }
        var keys = Object.keys(obj);
        for (var k = 0; k < keys.length; k++) {
            var v = obj[keys[k]];
            if (v && typeof v === 'object') {
                Utils.eliminarClavesProfundo(v, claves);
            }
        }
    },
    findInstruccionesEnFormato: function(formato, codigoComprobacion) {
        if (!formato || !formato.comprobaciones) return null;
        return Utils._findInstruccionesRecursivo(formato.comprobaciones, codigoComprobacion);
    },
    _findInstruccionesRecursivo: function(comprobaciones, codigo) {
        if (!comprobaciones) return null;
        for (var i = 0; i < comprobaciones.length; i++) {
            var c = comprobaciones[i];
            if (c.codigo === codigo) return c.instrucciones;
            var childComprobaciones = c.comprobaciones || c.hijas || [];
            if (childComprobaciones.length) {
                var found = Utils._findInstruccionesRecursivo(childComprobaciones, codigo);
                if (found !== null) return found;
            }
        }
        return null;
    },
    validarAlineamientoCaracteristicas: function(caractsExpediente, caractsFormato) {
        var diferencias = [];
        Utils._compararCaracteristicasRecursivo(caractsExpediente, caractsFormato, diferencias);
        return diferencias;
    },
    _compararCaracteristicasRecursivo: function(caractsExp, caractsForm, diferencias) {
        if (!caractsExp || !caractsForm) return;
        caractsExp.forEach(function(ce) {
            var cf = caractsForm.find(function(c) { return c.nombre === ce.nombre; });
            if (!cf) {
                diferencias.push({ tipo: 'caracteristica', nombre: ce.nombre, error: 'No existe en el formato' });
            } else if (ce.descripcion !== cf.descripcion) {
                diferencias.push({ tipo: 'caracteristica', nombre: ce.nombre, error: 'Descripción diferente' });
            }
            if (ce.hijas && ce.hijas.length) {
                Utils._compararCaracteristicasRecursivo(ce.hijas, cf ? cf.hijas : [], diferencias);
            }
        });
        if (caractsForm) {
            caractsForm.forEach(function(cf) {
                if (!caractsExp.find(function(c) { return c.nombre === cf.nombre; })) {
                    diferencias.push({ tipo: 'caracteristica', nombre: cf.nombre, error: 'Nueva en formato, no en expediente' });
                }
            });
        }
    },
    validarAlineamientoComprobaciones: function(comprosExpediente, comprosFormato) {
        var diferencias = [];
        Utils._compararComprobacionesRecursivo(comprosExpediente, comprosFormato, diferencias);
        return diferencias;
    },
    _compararComprobacionesRecursivo: function(comprosExp, comprosForm, diferencias) {
        if (!comprosExp || !comprosForm) return;
        comprosExp.forEach(function(ce) {
            var cf = comprosForm.find(function(c) { return c.codigo === ce.codigo; });
            if (!cf) {
                diferencias.push({ tipo: 'comprobacion', codigo: ce.codigo, error: 'No existe en el formato' });
            } else if (ce.descripcion !== cf.descripcion) {
                diferencias.push({ tipo: 'comprobacion', codigo: ce.codigo, error: 'Descripción diferente' });
            }
            if (ce.hijas && ce.hijas.length) {
                Utils._compararComprobacionesRecursivo(ce.hijas, cf ? cf.hijas : [], diferencias);
            }
        });
        if (comprosForm) {
            comprosForm.forEach(function(cf) {
                if (!comprosExp.find(function(c) { return c.codigo === cf.codigo; })) {
                    diferencias.push({ tipo: 'comprobacion', codigo: cf.codigo, error: 'Nueva en formato, no en expediente' });
                }
            });
        }
    },
    async: function (executor) {
        return new Promise((resolve, reject) => {
            try {
                executor(resolve, reject);
            } catch (e) {
                reject(e);
            }
        });
    },
    getInspeccionPath(path, inspeccion) {
        const insp = inspeccion.id,
            provincia = inspeccion.direccionInspeccion && inspeccion.direccionInspeccion.provincia ? inspeccion.direccionInspeccion.provincia : "00",
            formato = inspeccion.formato && inspeccion.formato.codigo ? inspeccion.formato.codigo.replaceAll(/\s/g, "") : '00',
            completeFilename = 'SIMECAL/' + (insp ? `${formato}/${provincia}/${insp}/${path}` : `${formato}/${provincia}/${path}`);
        
        return completeFilename;
    },
    grabarAudio(rform, name, path, setFunction) {
        navigator.device.capture.captureAudio(
            function (mediafiles) {
                Utils.onCaptureMedia(mediafiles, { rform, name, path, setFunction });
            },
            Utils.onCaptureError,
            { limit: 1 }
        );
    },
    capturarFoto(rform, name, path, setFunction) {
        EventBus.$emit("capturarFoto", Utils.onCaptureMedia, { rform, name, path, setFunction });
    },
    grabarVideo(rform, name, path, setFunction) {
        EventBus.$emit("grabarVideo", Utils.onCaptureMedia, { rform, name, path, setFunction });
    },
    onCaptureMedia: async function (mediaFiles, { rform, name, path, setFunction }) {
        // 1) Obtener ubicación (si falla, seguimos sin GPS)
        const coordsPromise = new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(
                pos => resolve(pos.coords),
                err => {
                    console.warn('No se pudo obtener la ubicación:', err);
                    resolve(null);
                },
                { enableHighAccuracy: false, timeout: 3000, maximumAge: 60000 }
            );
        });
        for (let i = 0; i < mediaFiles.length; i++) {
            let url = mediaFiles[i];
            if (typeof url == 'object') {
                url = url.fullPath;    
            }
            // let extension = url.split("/").slice(-1).join("/").split(".").slice(-1)[0];
            var docsForm = rform.getValue(name);
            if (!docsForm) {
                docsForm = [];
                var nameSplit = name.split(".");
                let lastName = nameSplit[nameSplit.length - 1];
                var nameMenos1 = nameSplit.slice(0, -1).join(".");
                var docsFormMenos1 = rform.getValue(nameMenos1);
                setFunction(!docsFormMenos1 ? rform.formData : docsFormMenos1, lastName, docsForm);
            }
            // const numFileName = (!docsForm || !docsForm.length ? 0 : Math.max(...docsForm.map(d => parseInt(d.nombre.split(']')[0].replace('[', '') || "0", 10) || 0))) + 1;
            
            // const filename = `[${numFileName}]_${url.split("/").slice(-1).join("").split(".").slice(0, -1).join(".")}`
            var documento = {
                nombre: url.split("/").slice(-1).join("").split(".").slice(0, -1).join("."),
                extension: url.split("/").slice(-1).join("/").split(".").slice(-1)[0],
            };

            const timestamp = moment().format("YYYYMMDDHHmmss");

            var rootDir = "Documents/";
            var filePath = rootDir + path;

            if (!window.requestFileSystem) {
                return;
            }
            let basePath = url;
            if (!basePath.startsWith("file://")) basePath = "file://" + basePath;

            if (documento.extension == 'jpg') {
                window.cordova.plugins.imagesaver.saveImageToGallery(basePath, onSaveImageSuccess, onSaveImageError);
                function onSaveImageSuccess() {
                    console.log('--------------success');
                };
                function onSaveImageError(error) {
                    console.log('--------------error: ' + error);
                };
            };

            const movedFile = await Utils.moveFile(basePath, filePath, `${timestamp}_${documento.nombre + "." + documento.extension}`);
            console.log("movedFile", movedFile);
            
            documento.offlinePath = movedFile.fullPath;
            documento._localURL = movedFile.nativeURL;
            // Sobreimprimir fecha cuando se nos diga
            if (documento.extension == 'jpg') {
                // sobreimprimir fecha a la imagen
                // Añadido en Utils.addGpsExif
                // Utils.sobreimprimirFecha(documento._localURL, documento.offlinePath);
                // ⬇️ aquí metemos los EXIF GPS en el fichero final
                coordsPromise.then(coords => {
                    if (coords) {
                        Utils.addGpsExif(
                            documento.offlinePath,
                            coords.latitude,
                            coords.longitude
                        ).catch(e => console.error('Error añadiendo EXIF GPS:', e));
                    }
                });


            }
            documento.alreadySaved = true;
            docsForm.push(documento);
        }
    },
    onCaptureError(error) {
        alert(
            error.message
        );
    },
    addGpsExif(path, lat, lon, fechaParam) {
        return new Promise((resolve, reject) => {
            if (!window.requestFileSystem) {
                resolve();
                return;
            }

            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {

                const handleFileEntry = (fileEntry) => {
                    fileEntry.file(file => {
                        const reader = new FileReader();
                        reader.onloadend = async function () {
                            try {
                                const arrayBuffer = this.result;

                                // ArrayBuffer -> binary string
                                const bytes = new Uint8Array(arrayBuffer);
                                let binary = '';
                                for (let i = 0; i < bytes.byteLength; i++) {
                                    binary += String.fromCharCode(bytes[i]);
                                }

                                // binary -> base64 -> dataURL
                                const base64 = btoa(binary);
                                let dataUrl = 'data:image/jpeg;base64,' + base64;

                                // 1) Cargar EXIF existentes
                                let exifObj;
                                try {
                                    exifObj = piexif.load(dataUrl);
                                } catch (e) {
                                    // Si no hay EXIF, partimos de objeto vacío
                                    exifObj = { '0th': {}, Exif: {}, GPS: {}, '1st': {} };
                                }
                                if (!exifObj.GPS) exifObj.GPS = {};
                                if (!exifObj.Exif) exifObj.Exif = {};
                                if (!exifObj['0th']) exifObj['0th'] = {};

                                // 2) Determinar fecha a pintar (si vamos a sobreimprimir)
                                let fechaTexto = fechaParam;
                                if (!fechaTexto) {
                                    const dto = exifObj.Exif[piexif.ExifIFD.DateTimeOriginal];
                                    if (dto) {
                                        // DateTimeOriginal suele venir "YYYY:MM:DD HH:mm:ss"
                                        // Si quieres transformarlo al mismo formato que antes:
                                        // 2024:01:27 10:11:12 -> 27/01/2024 10:11:12
                                        try {
                                            const [fechaPart, horaPart] = dto.split(' ');
                                            const [y, m, d] = fechaPart.split(':');
                                            fechaTexto = `${d}/${m}/${y} ${horaPart}`;
                                        } catch (e) {
                                            fechaTexto = dto; // si falla el parseo, lo ponemos tal cual
                                        }
                                    }
                                }
                                if (!fechaTexto) {
                                    fechaTexto = moment().format("DD/MM/YYYY HH:mm:ss");
                                }

                                // 3) (Opcional) sobreimprimir la fecha sobre la imagen
                                let dataUrlParaExif = dataUrl;
                                if (Utils.sobreimprimir) {
                                    try {
                                        dataUrlParaExif = await drawDateOnImage(dataUrl, fechaTexto);
                                        exifObj['0th'][piexif.ImageIFD.Orientation] = 1;
                                    } catch (e) {
                                        console.warn('No se pudo sobreimprimir la fecha:', e);
                                    }
                                }

                                // 4) Actualizar sólo la parte GPS si tenemos coords
                                if (lat != null && lon != null) {
                                    exifObj.GPS[piexif.GPSIFD.GPSLatitudeRef] = lat >= 0 ? 'N' : 'S';
                                    exifObj.GPS[piexif.GPSIFD.GPSLongitudeRef] = lon >= 0 ? 'E' : 'W';
                                    exifObj.GPS[piexif.GPSIFD.GPSLatitude] = degToRational(Math.abs(lat));
                                    exifObj.GPS[piexif.GPSIFD.GPSLongitude] = degToRational(Math.abs(lon));
                                }

                                // (Opcional) si quieres actualizar DateTime también en EXIF:
                                // const now = new Date();
                                // const dateStr =
                                //   `${now.getFullYear()}:` +
                                //   `${pad2(now.getMonth() + 1)}:` +
                                //   `${pad2(now.getDate())} ` +
                                //   `${pad2(now.getHours())}:` +
                                //   `${pad2(now.getMinutes())}:` +
                                //   `${pad2(now.getSeconds())}`;
                                // exifObj['0th'][piexif.ImageIFD.DateTime] = dateStr;

                                const exifBytes = piexif.dump(exifObj);

                                // 5) Insertar EXIF (originales + GPS) en el dataURL final
                                const finalDataUrl = piexif.insert(exifBytes, dataUrlParaExif);
                                const finalBase64 = finalDataUrl.split(',')[1];

                                // base64 -> ArrayBuffer
                                const finalBinary = atob(finalBase64);
                                const finalBuffer = new ArrayBuffer(finalBinary.length);
                                const finalBytes = new Uint8Array(finalBuffer);
                                for (let i = 0; i < finalBinary.length; i++) {
                                    finalBytes[i] = finalBinary.charCodeAt(i);
                                }

                                // Se reescribe la MISMA entrada, y el EXIF nuevo puede ocupar
                                // menos que el que traía: sin vaciarla quedaría cola del JPEG
                                // anterior detrás del nuevo.
                                const blob = new Blob([finalBuffer], { type: 'image/jpeg' });
                                FileUtils.writeFull(fileEntry, blob, () => resolve(), reject);

                            } catch (e) {
                                reject(e);
                            }
                        };
                        reader.onerror = reject;
                        reader.readAsArrayBuffer(file);
                    }, reject);
                };

                // Misma lógica de rutas que tu moveFile
                if (path.startsWith('file://')) {
                    window.resolveLocalFileSystemURL(path, handleFileEntry, reject);
                } else {
                    fs.root.getFile(path, { create: false }, handleFileEntry, reject);
                }

            }, reject);
        });
    },

    // imgSrc será una url o una imagen base64 o algo que pueda ser interpretado por un Image
    // sobreimprimirFecha(imgSrc, offlinePath, fecha) {
    //     if (!Utils.sobreimprimir) { return; }
    //     // vamos a obtener el tamaño de la imagen
    //     var img = new Image();
    //     img.onload = function() {
    //         var canvas = document.createElement('canvas');
    //         canvas.width = img.width;
    //         canvas.height = img.height;
    //         var ctx = canvas.getContext('2d');
    //         ctx.drawImage(img, 0, 0);
    //         ctx.font = 'bold 20px Arial';
    //         ctx.fillStyle = 'red';
    //         EXIF.getData(img, function() {
    //             if (!fecha) {
    //                 fecha = EXIF.getTag(this, "DateTimeOriginal");
    //             }
    //             if (!fecha) {fecha = moment().format("DD/MM/YYYY HH:mm:ss");}
    //             ctx.fillText(fecha, 10, 50);
    //             var base64 = canvas.toDataURL();
    //             console.log(base64);
    //             console.log(offlinePath);
    //             DocumentoOffline.saveBase64(base64, offlinePath);
    //         });
    //     };
    //     img.src = imgSrc;
    // },
    stringToColor: function (str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        var c = (hash & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
        return "#" + "00000".substring(0, 6 - c.length) + c;
    },
    getNestedProperty: function(obj, path) {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    },
    meses() {
        return [
            { value: 1, text: "Enero" },
            { value: 2, text: "Febrero" },
            { value: 3, text: "Marzo" },
            { value: 4, text: "Abril" },
            { value: 5, text: "Mayo" },
            { value: 6, text: "Junio" },
            { value: 7, text: "Julio" },
            { value: 8, text: "Agosto" },
            { value: 9, text: "Septiembre" },
            { value: 10, text: "Octubre" },
            { value: 11, text: "Noviembre" },
            { value: 12, text: "Diciembre" }
        ];
    },
    getMes(mes) {
        return this.meses().filter(m => m.value == mes)[0].text;
    },
}

// Helper: dibuja la fecha sobre un dataURL y devuelve otro dataURL (sin EXIF)
function drawDateOnImage(dataUrl, textoFecha) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            try {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');

                // Dibujamos la imagen original
                ctx.drawImage(img, 0, 0);

                // Configuramos fuente y calculamos medidas
                const fontSize = Math.max(16, Math.round(img.width * 0.02));
                // 2% del ancho como tamaño, mínimo 16px (ajusta a gusto)
                ctx.font = `bold ${fontSize}px Arial`;

                const paddingX = fontSize * 0.4; // margen horizontal
                const paddingY = fontSize * 0.4; // margen vertical
                const textMetrics = ctx.measureText(textoFecha);
                const textWidth = textMetrics.width;
                const textHeight = fontSize; // aproximación suficiente para esto

                // Posición (puedes moverla donde quieras)
                const x = 10;
                const y = 10 + textHeight; // 10px desde arriba + altura del texto

                // Fondo blanco semitransparente
                ctx.save();
                ctx.fillStyle = 'rgba(255, 255, 255, 0.3)'; // blanco 30% opaco
                ctx.fillRect(
                    x - paddingX,
                    y - textHeight - paddingY / 2,
                    textWidth + paddingX * 2,
                    textHeight + paddingY
                );
                ctx.restore();

                // Texto en negro encima
                ctx.fillStyle = 'black';
                ctx.fillText(textoFecha, x, y);

                const outDataUrl = canvas.toDataURL('image/jpeg'); // puedes pasar calidad si quieres
                resolve(outDataUrl);
            } catch (e) {
                reject(e);
            }
        };
        img.onerror = reject;
        img.src = dataUrl;
    });
}



// helpers privados
function degToRational(deg) {
    const d = Math.floor(deg);
    const minFloat = (deg - d) * 60;
    const m = Math.floor(minFloat);
    const secFloat = (minFloat - m) * 60;
    const s = Math.round(secFloat * 100);

    return [
        [d, 1],
        [m, 1],
        [s, 100]
    ];
}

function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
}

export default Utils;